import React from "react";

const BooleanCell = props => {
  return <td>{props.dataItem[props.field] ? "yes" : "no"}</td>;
};

export default BooleanCell;
